/* eslint-disable @typescript-eslint/naming-convention */
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { DispatchFilterService } from './dispatch-filter.service';
import { HotToastService } from '@ngneat/hot-toast';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import moment from 'moment';
import { Observable, ReplaySubject, forkJoin, of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, filter, map, startWith, switchMap } from 'rxjs/operators';
import { ZuperDialogService } from '@zuper/components/zuper-dialog/zuper-dialog.service';
import { SaveFilterComponent } from 'app/components/datagrid/save-filter.component';
import { DispatchFilterOptions, DispatchFilterTabsConfig } from './dispatch-filter.interface';
import { DispatchBoardService } from '../dispatch-board/dispatch-board.service';
import { ModuleAccess } from '../dispatch-board/dispatch-board.interface';
import { TagOptions } from 'app/components/tags/tags.interface';
import _ from 'lodash';
import { AdvanceFilterService } from 'app/components/quick-filter/advance-filter/advance-filter.service';
import { AdditionalFilter } from 'app/components/quick-filter/advance-filter/advance-filter.interface';

@Component({
  selector: 'app-dispatch-filter',
  templateUrl: './dispatch-filter.component.html',
  styleUrls: ['./dispatch-filter.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DispatchFilterComponent implements OnInit, OnChanges {
  @Input() selectedModule: 'GRID' | 'EMPLOYEE' | 'SCHEDULER' | 'MAP' = 'GRID';
  @Input() currentTab: 'JOBS' | 'ROUTES' = 'JOBS';
  @Input() isNewFilter: boolean = false;
  @Input() isMapViewEnabled: boolean = false;
  @Input() dispatchFilterValues: any = null;
  @Input() filterOptions: DispatchFilterOptions;
  @Input() filterOptionalValues: any = {};
  @Input() filterFormGroup: UntypedFormGroup; //Its only applicable when we want filter form in parent component
  @Input() saveFilterByDefault: boolean;
  @Input() moduleAccess: ModuleAccess;
  @Input() hideSaveFilter: boolean;
  @Input() filterTabs: DispatchFilterTabsConfig;
  @Input() selectedTeamUid?: string = null;
  @Input() additionalFilters?: AdditionalFilter = {};
  @Input() parentModule?: string;
  @Output() filterEmitter: EventEmitter<any> = new EventEmitter();

  selectedFilterModule: any = null;
  filterModuleTabs: any[] = [];
  dateFormat: 'DD/MM/YYYY';
  filterAPIUrls: any = null;
  jobsCategory: any[] = [];
  skills: any[] = [];
  dateTypes: any[] = [{
    dateType: 'Any',
    dateKey: 'ANY'
  }, {
    dateType: 'Today',
    dateKey: 'TODAY',
    dateValue: [moment(), moment()]
  }, {
    dateType: 'Tomorrow',
    dateKey: 'TOMORROW',
    dateValue: [moment().add(1, 'days'), moment().add(1, 'days')]
  }, {
    dateType: 'This Week',
    dateKey: 'WEEK',
    dateValue: [moment().startOf('week'), moment().endOf('week')]
  }, {
    dateType: 'This Month',
    dateKey: 'MONTH',
    dateValue: [moment().startOf('month'), moment().endOf('month')]
  }, {
    dateType: 'Custom Range',
    dateKey: 'CUSTOM'
  }];
  priorityTypes: any[] = [{
    priorityType: 'All',
    priorityKey: 'ALL'
  }, {
    priorityType: 'Low',
    priorityKey: 'LOW'
  }, {
    priorityType: 'Medium',
    priorityKey: 'MEDIUM'
  }, {
    priorityType: 'High',
    priorityKey: 'HIGH'
  }, {
    priorityType: 'Urgent',
    priorityKey: 'URGENT'
  }];
  routerOptimize: any[] = [{
    key: 'Any',
    value: 'ANY'
  }, {
    key: 'Yes',
    value: true
  }, {
    key: 'No',
    value: false
  }];
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  filterModuleRenderedInfo: any = {
    'GRID': false,
    'EMPLOYEE': false,
    'SCHEDULER': false,
    'MAP': false
  };
  filterForm: UntypedFormGroup;
  saveAsFilter: boolean = false;
  isLoaded: boolean = true;
  moduleName: string = 'DISPATCH_BOARD';

  //Work Order
  jobFilterForm: UntypedFormGroup;
  jobsStatuses: any[] = [];
  isAnyStatus: boolean = true;
  territoryFetching: boolean = false;
  territoryParamObj: any = {
    count: 10,
    page: 1
  };
  territoryPagination: any = {
    loadingIndex: 1,
    totalPage: 1,
    keyword: ''
  };
  territoryValueSubject: ReplaySubject<string | null> = new ReplaySubject<string | null>();
  territoryOptions: any[] = [];
  territories: Observable<any[]> = new Observable<any[]>();
  customerFetching: boolean = false;
  customerParamObj: any = {
    'count': 10,
    'page': 1,
    'filter.is_active': true
  };
  customerPagination: any = {
    loadingIndex: 1,
    totalPage: 1,
    keyword: ''
  };
  customerValueSubject: ReplaySubject<string | null> = new ReplaySubject<string | null>();
  customerOptions: any[] = [];
  customers: Observable<any[]> = new Observable<any[]>();
  organizationFetching: boolean = false;
  organizationParamObj: any = {
    'count': 10,
    'page': 1,
    'filter.is_active': true
  };
  organizationPagination: any = {
    loadingIndex: 1,
    totalPage: 1,
    keyword: ''
  };
  organizationValueSubject: ReplaySubject<string | null> = new ReplaySubject<string | null>();
  organizationOptions: any[] = [];
  organizations: Observable<any[]> = new Observable<any[]>();
  propertyFetching: boolean = false;
  propertyParamObj: any = {
    'count': 10,
    'page': 1,
    'filter.is_active': true
  };
  propertyPagination: any = {
    loadingIndex: 1,
    totalPage: 1,
    keyword: ''
  };
  propertyValueSubject: ReplaySubject<string | null> = new ReplaySubject<string | null>();
  propertyOptions: any[] = [];
  properties: Observable<any[]> = new Observable<any[]>();

  //Scheduler
  scheduleFilterForm: UntypedFormGroup;
  schedulerJobsStatuses: any[] = [];
  isSchedulerAnyStatus: boolean = true;
  schedulerTerritoryFetching: boolean = false;
  schedulerTerritoryParamObj: any = {
    count: 10,
    page: 1
  };
  schedulerTerritoryPagination: any = {
    loadingIndex: 1,
    totalPage: 1,
    keyword: ''
  };
  schedulerTerritoryValueSubject: ReplaySubject<string | null> = new ReplaySubject<string | null>();
  schedulerTerritoryOptions: any[] = [];
  schedulerTerritories: Observable<any[]> = new Observable<any[]>();
  schedulerCustomerFetching: boolean = false;
  schedulerCustomerParamObj: any = {
    'count': 10,
    'page': 1,
    'filter.is_active': true
  };
  schedulerCustomerPagination: any = {
    loadingIndex: 1,
    totalPage: 1,
    keyword: ''
  };
  schedulerCustomerValueSubject: ReplaySubject<string | null> = new ReplaySubject<string | null>();
  schedulerCustomerOptions: any[] = [];
  schedulerCustomers: Observable<any[]> = new Observable<any[]>();
  schedulerOrganizationFetching: boolean = false;
  schedulerOrganizationParamObj: any = {
    'count': 10,
    'page': 1,
    'filter.is_active': true
  };
  schedulerOrganizationPagination: any = {
    loadingIndex: 1,
    totalPage: 1,
    keyword: ''
  };
  schedulerOrganizationValueSubject: ReplaySubject<string | null> = new ReplaySubject<string | null>();
  schedulerOrganizationOptions: any[] = [];
  schedulerOrganizations: Observable<any[]> = new Observable<any[]>();
  schedulerPropertyFetching: boolean = false;
  schedulerPropertyParamObj: any = {
    'count': 10,
    'page': 1,
    'filter.is_active': true
  };
  schedulerPropertyPagination: any = {
    loadingIndex: 1,
    totalPage: 1,
    keyword: ''
  };
  schedulerPropertyValueSubject: ReplaySubject<string | null> = new ReplaySubject<string | null>();
  schedulerPropertyOptions: any[] = [];
  schedulerProperties: Observable<any[]> = new Observable<any[]>();

  //Technician
  employeeFilterForm: UntypedFormGroup;
  employeeTerritoryFetching: boolean = false;
  employeeTerritoryParamObj: any = {
    count: 10,
    page: 1
  };
  employeeTerritoryPagination: any = {
    loadingIndex: 1,
    totalPage: 1,
    keyword: ''
  };
  employeeTerritoryValueSubject: ReplaySubject<string | null> = new ReplaySubject<string | null>();
  employeeTerritoryOptions: any[] = [];
  employeeTerritories: Observable<any[]> = new Observable<any[]>();

  //Maps
  mapFilterForm: UntypedFormGroup;
  mapRouteFetching: boolean = false;
  mapRouteParamObj: any = {
    'limit': 10,
    'page': 1
  };
  mapRoutePagination: any = {
    loadingIndex: 1,
    totalPage: 1,
    keyword: ''
  };
  mapRouteValueSubject: ReplaySubject<string | null> = new ReplaySubject<string | null>();
  mapRouteOptions: any[] = [];
  mapRoutes: Observable<any[]> = new Observable<any[]>();

  //Advanced Filters
  appliedFilter = { grid: [], grid_route: [], scheduler: [], scheduler_route: [], employee: [], map: [] };
  gridTagsOption: TagOptions = {
    module: 'JOB',
    preventNewTag: true
  };
  schedulerTagsOption: TagOptions = {
    module: 'JOB',
    preventNewTag: true
  };

  constructor(
    private dataCollectorService: DataCollectorService,
    private dispatchFilterService: DispatchFilterService,
    private utilityService: UtilityService,
    private zuperDialogService: ZuperDialogService,
    private toast: HotToastService,
    public dispatchBoardService: DispatchBoardService,
    private advanceFilterService: AdvanceFilterService
    ) {
    this.createFilterForm();
  }

  createFilterForm(): void {
    this.jobFilterForm = new UntypedFormGroup({
      routeName: new UntypedFormControl(null),
      routeOptimized: new UntypedFormControl('ANY'),
      routeDateFrom: new UntypedFormControl(null),
      routeDateTo: new UntypedFormControl(null),
      jobSearch: new UntypedFormControl(null),
      jobCategory: new UntypedFormControl([]),
      jobStatus: new UntypedFormControl([]),
      dueDateType: new UntypedFormControl('ANY'),
      dueDateFrom: new UntypedFormControl(null),
      dueDateTo: new UntypedFormControl(null),
      scheduleDateType: new UntypedFormControl('ANY'),
      scheduleDateFrom: new UntypedFormControl(null),
      scheduleDateTo: new UntypedFormControl(null),
      skills: new UntypedFormControl([]),
      territory: new UntypedFormControl([]),
      priority: new UntypedFormControl(null),
      tags: new UntypedFormControl([]),
      customer: new UntypedFormControl([]),
      organization: new UntypedFormControl([]),
      property: new UntypedFormControl([])
    });
    this.scheduleFilterForm = new UntypedFormGroup({
      routeName: new UntypedFormControl(null),
      routeOptimized: new UntypedFormControl('ANY'),
      jobSearch: new UntypedFormControl(null),
      jobCategory: new UntypedFormControl([]),
      jobStatus: new UntypedFormControl([]),
      dueDateType: new UntypedFormControl(),
      dueDateFrom: new UntypedFormControl(null),
      dueDateTo: new UntypedFormControl(null),
      skills: new UntypedFormControl([]),
      territory: new UntypedFormControl([]),
      priority: new UntypedFormControl(null),
      tags: new UntypedFormControl([]),
      customer: new UntypedFormControl([]),
      organization: new UntypedFormControl([]),
      property: new UntypedFormControl([])
    });
    this.employeeFilterForm = new UntypedFormGroup({
      employeeSearch: new UntypedFormControl(null),
      skills: new UntypedFormControl(null),
      territory: new UntypedFormControl([])
    });
    this.mapFilterForm = new UntypedFormGroup({
      route: new UntypedFormControl([])
    });
    this.filterForm = new UntypedFormGroup({
      jobs: this.jobFilterForm,
      schedule: this.scheduleFilterForm,
      employees: this.employeeFilterForm,
      maps: this.mapFilterForm
    });
  }

  ngOnInit(): void {
    this.filterAPIUrls = this.dispatchFilterService.filterAPIurls;
    this.dateFormat = this.utilityService.dateFormat;
    this.saveAsFilter = this.saveFilterByDefault;
    this.hideSaveFilter = this.hideSaveFilter ?? false;
    this.moduleName = this.currentTab === 'JOBS'? 'DISPATCH_BOARD': 'ROUTES';
    this.filterModuleTabs = this.getFilterModuleTabs();
    this.dispatchFilterService.dispatchCurrentTab = this.currentTab;
    if(this.hideSaveFilter) {
      this.saveAsFilter = false;
    }
    if (this.filterFormGroup) {
      this.filterFormGroup.addControl('filterOptions', this.filterForm);
    }
    this.setFilterFormValue();
  }

  getFilterModuleTabs(): any[] {
    return [{
      moduleKey: 'GRID',
      headerDisplayKey: 'dispatch.filter.header.grid',
      headerDisplayName: 'Filter Dispatchers Queue',
      showIf: this.filterTabs?.grid?.show || false
    }, {
      moduleKey: 'EMPLOYEE',
      headerDisplayKey: 'dispatch.filter.header.employee',
      headerDisplayName: 'Filter Users',
      showIf: this.filterTabs?.employee?.show || false
    }, {
      moduleKey: 'SCHEDULER',
      headerDisplayKey: 'dispatch.filter.header.scheduler',
      headerDisplayName: 'Filter Schedule',
      showIf: this.filterTabs?.scheduler?.show || false
    }, {
      moduleKey: 'MAP',
      headerDisplayKey: 'dispatch.filter.header.map',
      headerDisplayName: 'Filter Maps',
      showIf: this.filterTabs?.map?.show && (this.moduleAccess?.map && this.isMapViewEnabled)
    }];
  }

  updateTabSelection(): void {
    this.filterModuleTabs = this.getFilterModuleTabs();
    const selectedModuleTab: any = this.filterModuleTabs.find(moduleTab => (moduleTab.moduleKey === this.selectedModule && moduleTab.showIf));
    this.onTabChange(selectedModuleTab ?? this.filterModuleTabs[0]);
  }

  onTabChange(filterModule: any): void {
    if (this.selectedFilterModule?.moduleKey !== filterModule.moduleKey) {
      this.selectedFilterModule = filterModule;
    }
    if (this.filterModuleRenderedInfo[this.selectedFilterModule?.moduleKey] === false) {
      this.filterModuleRenderedInfo[this.selectedFilterModule?.moduleKey] = true;
    }
  }

  setFilterFormValue(): void {
    if (this.dispatchFilterValues?.filterOptions) {
      const filterValues: any = this.dispatchFilterValues?.filterOptions;
      this.setJobFilterValue(filterValues?.['grid'], filterValues?.['grid_route']);
      this.setEmployeeFilterValue(filterValues?.['employee']);
      this.setSchedulerFilterValue(filterValues?.['scheduler'], filterValues?.['scheduler_route']);
      this.setMapFilterValue(filterValues?.['map']);
    } else {
      this.resetFilter();
    }
    this.updateTabSelection();
  }

  setJobFilterValue(filterValue: any, filterRouteValue: any): void {
    const currentTab: string = this.currentTab.toLowerCase();
    filterValue = this.dispatchBoardService.removeFilterKeyWithValue('keyword', '', filterValue);
    this.appliedFilter.grid = filterValue;
    this.appliedFilter.grid_route = filterRouteValue;
    this.advanceFilterService.dispatchBoardFilterValues[currentTab]['grid'] = filterValue;
    this.advanceFilterService.dispatchBoardFilterValues[currentTab]['grid_route'] = filterRouteValue;
  }

  setSchedulerFilterValue(filterValue: any, filterRouteValue: any): void {
    const currentTab: string = this.currentTab.toLowerCase();
    filterValue = this.dispatchBoardService.removeFilterKeyWithValue('keyword', '', filterValue);
    this.appliedFilter.scheduler = filterValue;
    this.appliedFilter.scheduler_route = filterRouteValue;
    this.advanceFilterService.dispatchBoardFilterValues[currentTab]['scheduler'] = filterValue;
    this.advanceFilterService.dispatchBoardFilterValues[currentTab]['scheduler_route'] = filterRouteValue;
  }

  convertStringToArray(value: string): string[] {
    return value ? value.split(',') : [];
  }

  setEmployeeFilterValue(filterValue: any): void {
    const currentTab: string = this.currentTab.toLowerCase();
    filterValue = this.dispatchBoardService.removeFilterKeyWithValue('keyword', '', filterValue);
    this.appliedFilter.employee = filterValue;
    this.advanceFilterService.dispatchBoardFilterValues[currentTab]['employee'] = filterValue;
  }
  //#endregion Employee

  //#region Maps
  onMapRouteClear(): void {
    this.mapRoutes = of(this.filterMapRoute([]));
  }

  filterMapRoute(filterUids: any[]): any {
    const mapRouteOptionalValues = this.filterOptionalValues?.map || [];
    if (filterUids.length) {
      return mapRouteOptionalValues.filter((route: any) => filterUids.includes(route.route_uid));
    }
    else {
      return mapRouteOptionalValues;
    }
  }

  onMapRouteScrollToEnd(): void {
    if(this.parentModule === 'dispatch_manage_filter') {
      if (this.mapRoutePagination.loadingIndex < this.mapRoutePagination.totalPage) {
        this.mapRoutePagination.loadingIndex++;
        this.mapRouteParamObj['filter.keyword'] = this.mapRoutePagination.keyword;
        this.mapRouteParamObj['page'] = this.mapRoutePagination.loadingIndex;
        this.mapRouteFetching = true;
        const urlParams = this.utilityService.constructParam(this.mapRouteParamObj);
        this.dataCollectorService.getData(this.filterAPIUrls.routesUrl, urlParams).subscribe(
          (response: any) => {
            this.mapRouteFetching = false;
            this.mapRouteOptions = this.mapRouteOptions.concat(response.data);
            this.mapRoutes = this.mapFilterForm.get('route').valueChanges.pipe(
              startWith(''),
              map((value: any) => this.mapRouteOptions)
            );
          }, (error: any) => {
            this.mapRouteFetching = false;
          });
      }
    }
  }

  setMapFilterValue(filterValue: any): void {
    //Set options
    if (this.parentModule === 'dispatch_manage_filter') {
      const mapFilterValues = filterValue['filter.route_uid'];
      if (mapFilterValues?.length) {
        const getMapRoutesUrl = `${this.dataCollectorService.baseurl()}/routes`;
        const mapParams = { 'page': 1, 'count': 100, 'filter.route_uid': mapFilterValues.join(',') || '' };
        this.mapRouteFetching = true;
        this.dataCollectorService.getData(getMapRoutesUrl, mapParams).subscribe((response: any) => {
          this.mapRoutes = of(response?.data || []);
          this.mapRouteFetching = false;
          this.setMapRoutePrefillValues(filterValue);
        }, (error: any) => {
          this.mapRouteFetching = false;
          this.mapRoutes = of([]);
        });
      }

    }
    else {
      this.mapRoutes = of(this.filterOptionalValues?.map || []);
    }

    //Prefill values
    this.setMapRoutePrefillValues(filterValue);
  }

  async setMapRoutePrefillValues(filterValue: any): Promise<void> {
    const mapFilterValue: any = {
      route: await this.sanitizeMapRoutePrefillValues(filterValue?.['filter.route_uid'] || [], this.mapRoutes)
    };
    this.mapFilterForm.patchValue(mapFilterValue);
  }

  async sanitizeMapRoutePrefillValues(prefillValues: any[], optionalValues: Observable<any[]>): Promise<any> {
    const _optionalValues = await optionalValues.toPromise();
    const optionalValueUids = _optionalValues.map((routeDetails: any) => routeDetails?.route_uid);
    return prefillValues.filter((routeUid: any) => optionalValueUids.includes(routeUid));
  }

  onMapRouteSearch(): void {
    if(this.parentModule === 'dispatch_manage_filter') {
      this.mapRoutes = this.mapRouteValueSubject.pipe(
        distinctUntilChanged(),
        debounceTime(250),
        filter(value => (value !== null && value !== undefined)),
        switchMap(term => this.getMapRoute(term))
      );
    }
  }

  getMapRoute(input: string): Observable<any[]> {
    this.mapRoutePagination.keyword = input ? input : '';
    this.mapRouteParamObj['filter.keyword'] = this.mapRoutePagination.keyword;
    this.mapRouteParamObj['page'] = 1;
    const urlParams = this.utilityService.constructParam(this.mapRouteParamObj);
    this.mapRouteFetching = true;
    return this.dataCollectorService.getData(this.filterAPIUrls.routesUrl, urlParams)
      .pipe(
        catchError(() => of([])),
        map((response) => {
          this.mapRoutePagination.loadingIndex = response.current_page;
          this.mapRoutePagination.totalPage = response.total_pages;
          this.mapRouteOptions = response.data;
          this.mapRouteFetching = false;
          return response.data;
        }),
      );
  }

  //#endregion Maps

  //#region Save As Filter
  saveFilterAction(filterValues: any): void {
    const dialogRef = this.zuperDialogService.openCustom(SaveFilterComponent,
      {
        dismissible: false,
        extraClass: 'dispatch-save-filter'
      });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (!result.cancel) {
        const filterPayload = {
          quick_filter: {
            filter_applicability: result.filter_applicability,
            filter_name: result.filter_name,
            filter_options: filterValues,
            module_name: this.moduleName
          }
        };
        if (result.filter_applicability === 'USERS') {
          filterPayload.quick_filter['filter_applicable_to_users'] = result.value;
        } else if (result.filter_applicability === 'TEAMS') {
          filterPayload.quick_filter['filter_applicable_to_teams'] = result.value;
        }
        this.toast.loading('Saving New Filter', { id: 'save_dispatch_filter' });
        this.dataCollectorService.postData(this.filterAPIUrls.saveFilterUrl, filterPayload).subscribe((response: any) => {
          this.toast.close('save_dispatch_filter');
          this.toast.success(response.message);
          this.saveFilter(filterValues, response.data?.filter_uid);
        }, (error: any) => {
          this.toast.close('save_dispatch_filter');
        });
      }
    });
  }
  //#endregion

  applyOrSaveFilter(event: any): void {
    if(event) {
      if(event?.action === 'apply') {
        this.applyFilter();
      }
      if(event?.action === 'reset') {
        this.resetFilterPanel();
      }
    }
  }

  saveFilter(filterValues: any, filterUid?: string): void {
    this.filterEmitter.emit({
      isClosed: true,
      filter: filterValues,
      type: 'save',
      filterUid: filterUid ?? null
    });
  }

  applyFilter(): void {
    this.filterForm.markAllAsTouched();
    if (this.filterForm.valid) {
      const filterValues: any = this.getFilterValues();
      if (this.saveAsFilter) {
        this.saveFilterAction(filterValues);
      } else {
        this.saveFilter(filterValues);
      }
    }
  }

  getFilterValues(): any {
    return this.dispatchFilterService.getFilterValues(this.filterForm.value, this.dispatchFilterValues);
  }

  resetFilter(): void {
    this.filterForm.reset({
      jobs: {
        routeName: null,
        routeOptimized: 'ANY',
        routeDateFrom: null,
        routeDateTo: null,
        jobCategory: [],
        jobStatus: [],
        dueDateType: 'ANY',
        dueDateFrom: null,
        dueDateTo: null,
        scheduleDateType: 'ANY',
        scheduleDateFrom: null,
        scheduleDateTo: null,
        skills: [],
        territory: [],
        priority: null,
        tags: [],
        customer: [],
        organization: [],
        property: []
      },
      schedule: {
        routeName: null,
        routeOptimized: 'ANY',
        jobCategory: [],
        jobStatus: [],
        dueDateType: 'ANY',
        dueDateFrom: null,
        dueDateTo: null,
        skills: [],
        territory: [],
        priority: null,
        tags: [],
        customer: [],
        organization: [],
        property: []
      },
      employees: {
        employeeSearch: null,
        skills: null,
        territory: []
      },
      maps: {
        route: []
      }
    });
  }

  resetFilterPanel(): void {
    this.resetFilter();
    const filterValues: any = this.getFilterValues();
    this.filterEmitter.emit({
      isClosed: true,
      filter: filterValues,
      type: 'reset'
    });
  }

  closeFilterPanel(): void {
    this.filterEmitter.emit({ isClosed: true });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.dispatchFilterValues?.firstChange === false) {
      this.setFilterFormValue();
    }
    if (changes?.isNewFilter?.firstChange === false) {
      this.setFilterFormValue();
    }
    if (changes?.selectedModule?.firstChange === false || changes?.isMapViewEnabled?.firstChange === false) {
      this.updateTabSelection();
    }
  }
}
